import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { FR_APPLICATION_STATUSES } from '@/helpers/fundraising';
import { useCheckApplicationStatusById } from '@/query/queries/fundraising/useCheckApplicationStatusById';
import { useApplicationStatusByFundraisingId } from '@/hooks/shared/useApplicationStatusByFundraisingId';
import IconDone from './icon_done.svg';
import IconPending from './icon_pending.svg';
import IconWarn from './icon_warn.svg';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';

export const ReportingStatus = ({ report, applicationId, fundraisingId, setShowMessage }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('reporting');
  const { application } = useApplicationStatusByFundraisingId(fundraisingId);
  useCheckApplicationStatusById(applicationId);

  const { PRE_CHECKS, IN_REVIEW, APPROVED, REJECTED, CHANGES_REQUESTED } = FR_APPLICATION_STATUSES;

  const status = report?.status;

  const data = useMemo(() => {
    if (status === PRE_CHECKS) {
      return {
        icon: IconPending,
        title: t('reporting_upload_status.processing_documents'),
        desc: t('reporting_upload_status.checking_coverage'),
      };
    }

    if (status === APPROVED || status === IN_REVIEW) {
      return {
        icon: IconDone,
        title: t('reporting_upload_status.thank_you'),
        desc: t('reporting_upload_status.documents_received'),
      };
    }

    if (status === REJECTED || status === CHANGES_REQUESTED) {
      return {
        icon: IconWarn,
        title: t('reporting_upload_status.attention_needed'),
        desc: application?.comment || t('reporting_upload_status.upload_and_try_again'),
      };
    }
  }, [status]);

  if (!data || !report) return null;

  return (
    <div className={s.content}>
      <img
        src={data.icon}
        className={report?.status === PRE_CHECKS ? s.spin : ''}
        alt="icon"
        width={24}
        height={24}
      />
      <div className={s.title}>{data.title}</div>
      <div className={classnames(s.desc, 'f-body-regular')}>{data.desc}</div>
      <div className={s.buttons}>
        {status === CHANGES_REQUESTED ? (
          <button
            type="button"
            className={classnames(r.yellow_large, s.button)}
            onClick={() => setShowMessage(false)}
          >
            {t('reporting_upload_status.upload_files')}
          </button>
        ) : (
          <button
            type="button"
            className={classnames(r.yellow_large, s.button)}
            onClick={() => navigate(-1)}
            disabled={status === PRE_CHECKS}
          >
            {t('reporting_upload_status.back_to_fundraising')}
          </button>
        )}
      </div>
    </div>
  );
};
